<template>
  <div id="contact-form-success-modal">
    <div class="modal-container">
      <div class="close-btn-photo">
        <span @click="$emit('close')"><i class="fa-solid fa-xmark fa-lg"></i></span>
      </div>
      <div class="top-banner">
        <div class="w-100 d-flex flex-column justify-content-center align-items-center" style="gap: 10px;">
          <p class="text-center merriweather-reg-24">Notre coffret cadeau physique revient bientôt…</p>
          <p class="text-center raleway-reg-p15">Soyez les premiers informés et recevez une <span class="raleway-semi-p15">alerte exclusive dès qu’il sera disponible.</span></p>
          <div class="d-flex flex-column">
            <input type="text" v-model="email" class="input-query-email raleway-reg-p13" placeholder="Votre adresse e-mail">
            <p class="raleway-reg-p13 w-100 mb-0 text-danger mt-1" v-if="errorMessage && errorMessage !== ''">{{ errorMessage }}</p>
          </div>
          <div class="d-flex w-100 justify-content-center align-items-center mt-3">
            <div class="hortense-btn-primary" @click="submit()">ME PRÉVENIR</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import fetcher from 'packs/shared/api.js';
import { watch } from 'vue';
export default {
  name: 'modal-contact-form-success',
  props: ['giftBox'],
  data() {
    return {
      email: '',
      errorMessage: ''
    };
  },
  methods: {
    validEmail() {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(this.email);
    },
    async submit() {
      if (!this.validEmail()) {
        this.errorMessage = "Adresse e-mail non valide";
        return;
      } else {
        try {
          await fetcher.post('/gift_box_format_queries', {
            gift_box_format_query: {
              email: this.email,
              gift_box_id: this.giftBox?.id || null
            }
          });
          this.$emit('close');
        } catch (e) {
          console.log('Failed call due to', e)
        }
      }
    }
  },
  watch: {
    email() {
      this.errorMessage = "";
    }
  }
}
</script>
<style scoped lang="scss">
#contact-form-success-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; // backdrop layer behind the modal

  .modal-container {
    position: relative;
    bottom: 12%;
    width: 878px;
    max-height: auto;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    overflow-y: auto;
    z-index: 1000; // modal above backdrop
    padding: 45px;

    .close-btn-photo {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      cursor: pointer;

      span {
        width: 12px;
        height: 13px;
        color: #3B6152;
      }
    }

    .header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .lodging-name {
        margin-left: 6rem;

        img {
          width: 45px;
          position: absolute;
        }
      }
    }
  }

  @media only screen and (max-device-width: 480px) {
    .modal-container {
      width: 100% !important;
      z-index: 1001;
      padding: 20px;
    }
  }

  .top-banner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    i {
      font-size: 69px;
      color: #3B6152;
      margin-bottom: 20px;
    }
  }

  .text-green {
    color: #3B6152;
  }

  .input-query-email {
    border: 1px solid #3B6151;
    padding: 18px 20px 18px 20px;
    width: 605px;
    height: 50px;

    @media only screen and (max-device-width: 768px) {
      width: 100%;
    }

    &:focus {
      outline: none;
    }
  }

  .input-query-email::placeholder {
    color: #858686;
  }
}

</style>